import { render } from "./ViewResult.vue?vue&type=template&id=c7987200&scoped=true"
import script from "./ViewResult.vue?vue&type=script&lang=js"
export * from "./ViewResult.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=c7987200&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7987200"]])

export default __exports__